// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-ingredients-bottom-sheet {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0 20px;
  box-sizing: border-box;
}

/* Search section stays visible; never shrinks */
.search-section {
  flex-shrink: 0;
  width: 100%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--color-light-gray);
  border-radius: 8px;
  padding: 0 12px;
  border: 1px solid transparent;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  min-height: 44px;
  box-sizing: border-box;
}

.search-input-wrapper:focus-within {
  border-color: var(--color-primary-green);
  box-shadow: 0 0 0 2px var(--accent-ring);
}

.search-icon-slot,
.search-clear-slot {
  width: 32px;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.search-icon-slot {
  color: var(--color-dark-gray);
}

.search-input-field {
  flex: 1;
  border: none;
  background: none;
  padding: 0 8px;
  font-size: 16px;
  color: var(--color-black);
  outline: none;
  text-align: left;
  font-family: inherit;
  min-width: 0;
}

.search-input-field::placeholder {
  color: var(--color-dark-gray);
}

.clear-search-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-dark-gray);
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.clear-search-button:hover {
  background-color: var(--color-gray);
}

/* Filter Section - fixed so list scrolls below */
.filter-section {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 0 12px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-count {
  color: var(--color-black);
}

.filter-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Active Ingredients List - only this area scrolls */
.active-ingredients-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
}

.active-ingredient-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: var(--color-white);
  border: 1px solid var(--color-gray);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 72px;
}

.active-ingredient-item:hover {
  border-color: var(--color-primary-green);
  box-shadow: var(--shadow-sm);
}

.active-ingredient-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.active-name {
  color: var(--color-black);
  margin: 0;
}

.product-count {
  color: var(--color-dark-gray);
  margin: 0;
}

.active-ingredient-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.level-tag {
  padding: 4px 12px;
  border-radius: 16px;
  min-width: 80px;
  text-align: center;
}

.level-text {
  color: var(--text-on-accent) !important;
  font-weight: 600;
  margin: 0;
}

.chevron-icon {
  color: var(--color-gray);
  transition: transform 0.2s ease;
}

.active-ingredient-item:hover .chevron-icon {
  transform: translateX(2px);
}

/* Loading and Empty States */
.loading-state,
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.empty-state {
  color: var(--color-gray);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .active-ingredients-bottom-sheet {
    gap: 16px;
    padding: 0 16px 16px 16px;
  }
  
  .filter-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .filter-chips {
    width: 100%;
    justify-content: flex-start;
  }
  
  .active-ingredient-item {
    padding: 12px;
    min-height: 64px;
  }
  
  .active-ingredient-right {
    gap: 8px;
  }
  
  .level-tag {
    min-width: 70px;
    padding: 3px 10px;
  }
  
}

`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/ActiveIngredientsBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,wDAAwD;EACxD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;IACT,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;AAEF","sourcesContent":[".active-ingredients-bottom-sheet {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n/* Search section stays visible; never shrinks */\n.search-section {\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.search-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: var(--color-light-gray);\n  border-radius: 8px;\n  padding: 0 12px;\n  border: 1px solid transparent;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  min-height: 44px;\n  box-sizing: border-box;\n}\n\n.search-input-wrapper:focus-within {\n  border-color: var(--color-primary-green);\n  box-shadow: 0 0 0 2px var(--accent-ring);\n}\n\n.search-icon-slot,\n.search-clear-slot {\n  width: 32px;\n  min-width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.search-icon-slot {\n  color: var(--color-dark-gray);\n}\n\n.search-input-field {\n  flex: 1;\n  border: none;\n  background: none;\n  padding: 0 8px;\n  font-size: 16px;\n  color: var(--color-black);\n  outline: none;\n  text-align: left;\n  font-family: inherit;\n  min-width: 0;\n}\n\n.search-input-field::placeholder {\n  color: var(--color-dark-gray);\n}\n\n.clear-search-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-dark-gray);\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.clear-search-button:hover {\n  background-color: var(--color-gray);\n}\n\n/* Filter Section - fixed so list scrolls below */\n.filter-section {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px 0 12px;\n}\n\n.filter-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.total-count {\n  color: var(--color-black);\n}\n\n.filter-chips {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* Active Ingredients List - only this area scrolls */\n.active-ingredients-list {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.active-ingredient-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  background: var(--color-white);\n  border: 1px solid var(--color-gray);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-height: 72px;\n}\n\n.active-ingredient-item:hover {\n  border-color: var(--color-primary-green);\n  box-shadow: var(--shadow-sm);\n}\n\n.active-ingredient-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.active-name {\n  color: var(--color-black);\n  margin: 0;\n}\n\n.product-count {\n  color: var(--color-dark-gray);\n  margin: 0;\n}\n\n.active-ingredient-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.level-tag {\n  padding: 4px 12px;\n  border-radius: 16px;\n  min-width: 80px;\n  text-align: center;\n}\n\n.level-text {\n  color: var(--text-on-accent) !important;\n  font-weight: 600;\n  margin: 0;\n}\n\n.chevron-icon {\n  color: var(--color-gray);\n  transition: transform 0.2s ease;\n}\n\n.active-ingredient-item:hover .chevron-icon {\n  transform: translateX(2px);\n}\n\n/* Loading and Empty States */\n.loading-state,\n.empty-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.empty-state {\n  color: var(--color-gray);\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .active-ingredients-bottom-sheet {\n    gap: 16px;\n    padding: 0 16px 16px 16px;\n  }\n  \n  .filter-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .filter-chips {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .active-ingredient-item {\n    padding: 12px;\n    min-height: 64px;\n  }\n  \n  .active-ingredient-right {\n    gap: 8px;\n  }\n  \n  .level-tag {\n    min-width: 70px;\n    padding: 3px 10px;\n  }\n  \n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
